import type { CSSProperties } from 'react';

import { cn } from '@/shared/lib/utils';
import { ShadcnSkeleton } from '@/shared/ui/shadcn';

export interface SkeletonProps {
  /** Šířka proužku – px číslo nebo CSS délka. */
  width?: number | string;
  /** Výška proužku – px číslo nebo CSS délka. Default 11px. */
  height?: number | string;
  className?: string;
  'aria-label'?: string;
}

/**
 * Phoenix skeleton placeholder postavený nad shadcn <ShadcnSkeleton>. Drží Phoenix povrchový token a nabízí
 * convenience `width`/`height` pro shimmer proužky v tabulkách a pilulkách během asynchronního načítání.
 * Rozměry jsou na obalovém <span> (DOM), aby dynamický `style` nešel přes komponentu.
 */
export function Skeleton({
  width,
  height = 11,
  className,
  'aria-label': ariaLabel = 'Načítá se',
}: SkeletonProps) {
  const style: CSSProperties = { width, height };
  return (
    <span role="img" aria-label={ariaLabel} className="inline-block align-middle" style={style}>
      <ShadcnSkeleton className={cn('bg-phx-surface-3 rounded-phx-sm h-full w-full', className)} />
    </span>
  );
}
